<template>
    <section class="noData-found">
        <div class="noData-found-wrap">
            <div class="noData-found-icon">
                <img loading="lazy" src="@/assets/images/no-data-img.svg" alt="no-data-img">
            </div>
            <div class="noData-found-content">
                <h3 class="noData-found-title">{{$t('no-data-found', 'No data found')}}!</h3>
                <p class="noData-found-text">{{$t('cant-find-any-item', `We can't find any item matching your search.`)}}</p>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "NoDataFound",
}
</script>